import React from 'react';

export const MainLayoutLocaleContext = React.createContext({
  locale: 'en_GB',
});
